module.exports = __webpack_public_path__ + "img/0_dots.f6ac23d1.svg";